import moment from 'moment';

export default function getDateFinEcheancierManuel(lignesCommandes) {
  let dateFin = null;
  lignesCommandes.forEach((ligne) => {
    if (dateFin === null
      || (ligne.dateFin && moment(ligne.dateDebut).isAfter(moment(dateFin)))) {
      dateFin = ligne.dateFin;
    }
  });
  return dateFin ? new Date(dateFin) : null;
}
